import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  Flex,
  useColorModeValue,
  Text,
  Container,
  Grid,
  GridItem,
  useBreakpointValue,
  Center,
} from '@chakra-ui/react';

import { ChevronDownIcon } from '@chakra-ui/icons';

export default function SimpleAccordion() {
  const gridTemplateColumns = useBreakpointValue({ base: '1fr', md: 'repeat(2, 1fr)' });

  return (
    <Flex

      align={'center'}
      justify={'center'}
      // bg={useColorModeValue('gray.50', 'gray.800')}

    >
      <Container margin={"40px"} width="100%">
        <Center>
        <Grid templateColumns={gridTemplateColumns} gap={6}>
          <GridItem>
            <Accordion allowMultiple width="100%" bg="white" maxW="400px"
              minW={{ base: 'auto', 'xl': '500px' }} rounded="lg">
              <AccordionItem>
                <AccordionButton
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  bg={'gray.50'}
                  p={4}
                  _hover={{ bg: 'gray.200' }}
                >
                  <Text fontSize="md">How fast can you edit my Esssay?</Text>
                  <ChevronDownIcon fontSize="24px" />
                </AccordionButton>
                <AccordionPanel pb={4}>
                  <Text>Content for Accordion Item 1</Text>
                </AccordionPanel>
              </AccordionItem>
            </Accordion>
          </GridItem>
          <GridItem>
            <Accordion allowMultiple width="100%" maxW="400px"
              minW={{ base: 'auto', 'xl': '500px' }} bg="white" rounded="lg">
              <AccordionItem>
                <AccordionButton
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  bg={'gray.50'}
                  p={4}
                  _hover={{ bg: 'gray.200' }}
                >
                  <Text fontSize="md">What if you edit my paper and I'm not 100%
satisfied?</Text>
                  <ChevronDownIcon fontSize="24px" />
                </AccordionButton>
                <AccordionPanel pb={4}>
                  <Text>Content for Accordion Item 2</Text>
                </AccordionPanel>
              </AccordionItem>
            </Accordion>
          </GridItem>
          <GridItem>
            <Accordion allowMultiple width="100%" maxW="400px"
              minW={{ base: 'auto', 'xl': '500px' }} bg="white" rounded="lg">
              <AccordionItem>
                <AccordionButton
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  bg={'gray.50'}
                  p={4}
                  _hover={{ bg: 'gray.200' }}
                >
                  <Text fontSize="md">Do you also help with formatting when you edit
my essay?</Text>
                  <ChevronDownIcon fontSize="24px" />
                </AccordionButton>
                <AccordionPanel pb={4}>
                  <Text>Content for Accordion Item 3</Text>
                </AccordionPanel>
              </AccordionItem>
            </Accordion>
          </GridItem>
          <GridItem>
            <Accordion allowMultiple width="100%" maxW="400px"
              minW={{ base: 'auto', 'xl': '500px' }} bg="white" rounded="lg">
              <AccordionItem>
                <AccordionButton
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  bg={'gray.50'}
                  p={4}
                  _hover={{ bg: 'gray.200' }}
                >
                  <Text fontSize="md">Can you do an extra essay edit after my order
has been placed?</Text>
                  <ChevronDownIcon fontSize="24px" />
                </AccordionButton>
                <AccordionPanel pb={4}>
                  <Text>Content for Accordion Item 4</Text>
                </AccordionPanel>
              </AccordionItem>
            </Accordion>
          </GridItem>
          <GridItem>
            <Accordion allowMultiple width="100%" maxW="400px"
              minW={{ base: 'auto', 'xl': '500px' }} bg="white" rounded="lg">
              <AccordionItem>
                <AccordionButton
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  bg={'gray.50'}
                  p={4}
                  _hover={{ bg: 'gray.200' }}
                >
                  <Text fontSize="md">Is there a money-back guarantee with your
essay editing service?</Text>
                  <ChevronDownIcon fontSize="24px" />
                </AccordionButton>
                <AccordionPanel pb={4}>
                  <Text>Content for Accordion Item 5</Text>
                </AccordionPanel>
              </AccordionItem>
            </Accordion>
          </GridItem>
          <GridItem>
            <Accordion allowMultiple width="100%" maxW="400px"
              minW={{ base: 'auto', 'xl': '500px' }} bg="white" rounded="lg">
              <AccordionItem>
                <AccordionButton
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  bg={'gray.50'}
                  p={4}
                  _hover={{ bg: 'gray.200' }}
                >
                  <Text fontSize="md">Is it possible to get an originality report when
you edit my paper?</Text>
                  <ChevronDownIcon fontSize="24px" />
                </AccordionButton>
                <AccordionPanel pb={4}>
                  <Text>Content for Accordion Item 6</Text>
                </AccordionPanel>
              </AccordionItem>
            </Accordion>
          </GridItem>
        </Grid>
        </Center>
      </Container>

    </Flex>
  );
}
